export default {
  path: '/fleet/settings/department',
  name: 'Department',
  component: () => import(/* webpackChunkName: "fleet" */ '../views/DepartmentView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
